import React from 'react';
import Rsee from '../assets/images/Rsee.webp';
import splashImage from '../assets/images/splashImage.webp';
import Star1 from '../assets/images/Star1.webp';
import Star2 from '../assets/images/Star2.webp';
import Image from './Image';
import './style.css';

const Loader = ({ children, spinning }) => (
  <div className={`${spinning ? 'opacity-100' : ''}`}>
    <div
      className={`absolute top-0 bottom-0 right-0 left-0 bg-white
        flex flex-col items-center justify-center w-full ${
          spinning ? 'block z-50' : 'hidden'
        } `}
    >
      <div className='h-1/2'>
        <Image src={splashImage} />
      </div>
      <div className='h-1/2 grid grid-cols-1'>
        <Image
          src={Star1}
          wrapperClassName='place-self-end animate-pulse my-3'
        />
        <Image src={Rsee} wrapperClassName='place-self-center' />
        <text className='text-md mt-5'>{locales('title.easy.reserve')}</text>
        <Image
          src={Star2}
          wrapperClassName='place-self-start animate-pulse my-4'
        />
      </div>
    </div>
    <div className={`${spinning && 'opacity-0'}`}>{children}</div>
    {<div className='before:animate-spin crescent'></div>}
  </div>
);

export default Loader;
